// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"1242":"f8c34e00","2900":"0b661f96","4077":"62efb98e","4109":"6e6075ed"}[chunkId] + ".chunk.js";
};